import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

import config from 'config';
import { useGlobalContext } from 'store';

export const useTracking = () => {
  const { user } = useGlobalContext();
  const sendDataToGTM = useGTMDispatch();
  const getFormattedTrackData = ({
    event,
    action,
    label,
    category,
    dimensions,
    page,
  }: {
    event: 'event' | 'click' | 'callback' | 'pageview';
    page?: string;
    action?: string;
    label?: string | number;
    category?: string;
    dimensions?: Record<string, string | number | boolean>;
  }) => {
    return {
      ...(event && { event: `${event}` }),
      ...(category && { 'event-category': `${config.app.short}-portal:${category}` }),
      ...(action && { 'event-action': action }),
      ...(label && { 'event-label': label }),
      ...(page && { page: page }),
      ...dimensions,
    };
  };

  const trackWithUserData = (dataLayer?: object) => {
    if (!Boolean(user?.resellerId) || !Boolean(user?.cycle?.currentCycle)) {
      return null;
    }

    const userInfos = {
      user_id: user?.resellerId,
      cd_ciclo: `${user?.cycle?.currentCycle}`,
    };

    sendDataToGTM({
      ...userInfos,
      ...dataLayer,
    });
  };

  return {
    getFormattedTrackData,
    sendDataToGTM,
    trackWithUserData,
  };
};
